class UpcartWatcher {
  constructor(productIdsToWatch = []) {
    this.attachCartHandlers();
  }

  attachCartHandlers() {
    console.log("Attaching UpCart watcher...");

    window.addEventListener(
      'aftersell-upcart:public-events:cart-loaded',
      (event) => {
        const cart = event.detail?.cart;
        setTimeout(() => {
            this.handleCart(cart);
        }, 150);
      }
    );
  }

  handleCart(cart) {
    this.upcartEl = document.querySelector('#upCart');
    if (!this.upcartEl?.shadowRoot) return;

    this.shadowContainer = this.upcartEl.shadowRoot.querySelector('#CartPopup');
    if (!this.shadowContainer) return;

    this.cartTotal = cart.total;

    this.tiers = this.shadowContainer.querySelectorAll(".upcart-internal-component-segmented-progress-bar__segment.upcart-public-component-segmented-progress-bar__segment");
    this.progressBar = this.shadowContainer.querySelector(".upcart-internal-component-segmented-progress-bar__segments-container");
    this.message = this.shadowContainer.querySelector(".upcart-internal-rewards__message");
    this.progressBar.style.gap = 0;

    this.bar1 = this.tiers[0] || null;
    this.milestone_middle = this.bar1.querySelector(".upcart-internal-component-segmented-progress-bar__milestone--middle");
    this.milestone_icon = this.bar1.querySelector(".upcart-internal-component-segmented-progress-bar__milestone-icon");
    this.fill = this.bar1.querySelector(".upcart-internal-component-segmented-progress-bar__segment-fill");


    

    if (!cart?.items?.length) return;

    const targetIds = [7664964763881];
    const jarId = [8699398095081];

    const totalQuantity = cart.items.reduce((sum, item) => {
      return sum + item.quantity;
    }, 0);

    // Step 1: Get all items’ raw quantities keyed by productId
    const totalTargetQuantity = cart.items.reduce((sum, item) => {
      return targetIds.includes(item.productId)
        ? sum + item.quantity
        : sum;
    }, 0);

    const totalJar = cart.items.reduce((sum, item) => {
      return jarId.includes(item.productId)
        ? sum + item.quantity
        : sum;
    }, 0);

    this.cartTotal = 7900 - this.cartTotal;
    const formattedTotal = this.formatMoney(this.cartTotal, upcartMoneyFormat);

    if (totalQuantity == totalTargetQuantity && cart.total < 7900 ) {
        console.log("should")
        this.milestone_middle.style.display = "none";
        this.message.innerHTML = `You’re ${formattedTotal} away from <strong>Free Shipping</strong>`;

    }else if(totalJar > 0 && cart.total < 6900){
        // this.milestone_middle.style.display = "none";
        console.log("jar jar")
        this.milestone_icon.style.backgroundColor = "#389b3e";
        this.milestone_middle.style.display = "block";
        this.fill.style.width = "100%";
        this.message.innerHTML = `You’re ${formattedTotal} away from <strong>Free Shipping</strong>`;
    }else{
        this.milestone_middle.style.display = "block";
    }

  }

  formatMoney(amount, format) {
    if (typeof amount === 'string') amount = amount.replace('.', '');
    let value = (amount / 100).toFixed(2);
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // add commas

    return format.replace(placeholderRegex, formattedValue);
    }



  hideBar(){
    this.barContainer.style.display = "none";
  }

}

new UpcartWatcher();
